var map = {
	"./00FF00.svg": 658,
	"./00FFE8.svg": 659,
	"./5C1A8E.svg": 660,
	"./FF0000.svg": 661,
	"./FF00FF.svg": 662,
	"./FFA500.svg": 663,
	"./FFFF00.svg": 664
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 657;